import { render } from "./integration-connect.vue?vue&type=template&id=736c0ede&scoped=true"
import script from "./integration-connect.vue?vue&type=script&lang=js"
export * from "./integration-connect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736c0ede"]])

export default __exports__